import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=501dae1e&scoped=true&"
import script from "./contractInfo.vue?vue&type=script&lang=js&"
export * from "./contractInfo.vue?vue&type=script&lang=js&"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=501dae1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501dae1e",
  null
  
)

component.options.__file = "contractInfo.vue"
export default component.exports